import type { TenantContext } from '@atlassian/jira-shared-types/src/tenant-context.tsx';

/**
 * TenantContext has several properties in it and not always is it obvious which one means which.
 *
 * See https://hello.atlassian.net/wiki/spaces/JPCE/pages/1234159989/FE+How+do+I+tell+which+admin+am+I
 */
export const isGlobalAdmin = (tenantContext: TenantContext): boolean => tenantContext.isAdmin;
